import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ChatAnalyse"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M13.305 22.5L12 21.75L15 16.5H19.5C20.3284 16.5 21 15.8284 21 15V6C21 5.17157 20.3284 4.5 19.5 4.5H4.5C3.67157 4.5 3 5.17157 3 6V15C3 15.8284 3.67157 16.5 4.5 16.5H11.25V18H4.5C2.84315 18 1.5 16.6569 1.5 15V6C1.5 4.34315 2.84315 3 4.5 3H19.5C21.1569 3 22.5 4.34315 22.5 6V15C22.5 16.6569 21.1569 18 19.5 18H15.87L13.305 22.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M14.25 6C14.5134 6 14.7576 6.13822 14.8931 6.36413L16.9246 9.75H19.5V11.25H16.5C16.2366 11.25 15.9924 11.1118 15.8569 10.8859L14.25 8.20774L10.3931 14.6359C10.2576 14.8618 10.0134 15 9.75 15C9.48655 15 9.24242 14.8618 9.10688 14.6359L7.07536 11.25H4.5V9.75H7.5C7.76345 9.75 8.00758 9.88822 8.14312 10.1141L9.75 12.7923L13.6069 6.36413C13.7424 6.13822 13.9866 6 14.25 6Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ChatAnalyse.vue"]]);
